export type manageFolderFilterSliceState = {
  folderName: string;
  pageNumber: number;
  activeTab : string;
  activeTabFolderCount : number | null
}

export const manageFolderFilterSliceInitialState: manageFolderFilterSliceState = (() => {
    
    return {
        folderName: "",
        pageNumber: 0,
        activeTab: "Personal folders",
        activeTabFolderCount : null
    }
})()